import { useEffect, useState } from 'react'
import './CoverPage.css'

interface CoverPageProps {
  onEnter: () => void
}

export function CoverPage({ onEnter }: CoverPageProps) {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    // 触发入场动画
    const timer = setTimeout(() => setIsLoaded(true), 100)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className={`cover-page ${isLoaded ? 'loaded' : ''}`}>
      {/* 主内容区域 */}
      <div className="cover-content">
        {/* 游戏名称 */}
        <div className="game-title">
          <h1 className="title-main">华夏志</h1>
        </div>
        
        {/* 进入按钮 */}
        <button 
          className="enter-button"
          onClick={onEnter}
          aria-label="进入游戏"
        >
          <span className="button-text">进入游戏</span>
        </button>
      </div>
    </div>
  )
}
